import {
  faAd,
  faAdd,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { GoogleMap, LoadScript, DrawingManager } from "@react-google-maps/api";
import { Link, useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import Select from "react-select";
import _ from "lodash";
import { toast } from "react-toastify";

// import ScriptLoaded from "./ScriptLoaded";
// let rates = {};
// let houryRates = {};
let path = [];
let pathsWithDetail = [];

const CreateRegion = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { allVehicles, categories } = useSelector((state) => state.vehicle);
  const navigate = useNavigate();
  const containerStyle = {
    width: "800px",
    height: "600px",
    margin: "10px 10px",
  };

  //

  let initialState = {
    lat: 38.685,
    lng: -115.234,
  };

  const [center, setcenter] = useState(initialState);
  const [ratesByMilage, setratesByMilage] = useState([]);
  const [ratesByHour, setratesByHour] = useState([]);
  const [ratesOfVehicle, setratesOfVehicle] = useState({});
  const [hourlyRatesOfVehicle, setHourlyRatesOfVehicle] = useState({});
  const [category, setCategory] = useState({});

  let x = 0;
  let y = 0;
  let z = 0;

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [region, setregion] = useState({
    name: "",
    distance_unit: "",
    distance_per_hour: 0,
    locationPoints: [],
  });
  //

  useEffect(() => {
    dispatch({
      type: "SHOW_VEHICLE_CATEGORY",
      payload: {
        token: token,
      },
    });
  }, []);

  const [saveClicked, setsaveClicked] = useState(false);

  const mapCreateHandler = async () => {
    if (!region?.name) {
      toast.warning("Please enter region name");
    } else {
      setsaveClicked(true);
      //
      //

      // if (path.length === 0) {
      //   toast.warning("Please draw a region on map");
      // } else if (region.name === "") {
      //   toast.warning("Please enter region name");
      // } else {
      for (let i in path) {
        let latlan =
          path[i]?.geometry?.location?.lat +
          "," +
          path[i]?.geometry?.location?.lng;
        var locationInfoDetail = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlan}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
        );

        pathsWithDetail.push(locationInfoDetail?.data?.results[0]);
      }

      const regionPayload = {
        name: region?.name,
        distance_unit: "km",
        distance_per_hour:
          region.distance_per_hour === 0 ? 20 : region.distance_per_hour,
        LocationPoints: pathsWithDetail,
        rate_by_milage: ratesByMilage.map((rate) => {
          return {
            category: rate?.category,
            rate: rate?.rate,
            min_fare: rate?.min_fare,
            start_fee: rate?.start_fee,
            vehicleName: rate?.vehicleName,
          };
        }),
        rate_by_hour: ratesByHour.map((rate) => {
          return {
            category: rate?.category,
            rate: rate?.rate,
            min_fare: rate?.min_fare,
            start_fee: rate?.start_fee,
            vehicleName: rate?.vehicleName,
          };
        }),
      };

      dispatch({
        type: "CREATE_REGION",
        payload: {
          regionPayload,
          token,
          navigate,
        },
      });

      path = [];
      pathsWithDetail = [];
      setratesOfVehicle({});
      setHourlyRatesOfVehicle({});

      // }
    }
  };

  return (
    <div>
      <div className="flex justify-between px-5 py-2 shadow-md items-center">
        <div className=" text-xl text-primary font-semibold">Create Region</div>
        <div className="flex space-x-5">
          <button
            onClick={mapCreateHandler}
            className={` ${
              saveClicked && "disabled bg-gray-300"
            } bg-secondary hover:bg-gray-300 hover:text-black text-white px-3 py-1 rounded-md cursor-pointer`}
          >
            Save
          </button>
          <Link to="/regions">
            <FontAwesomeIcon
              icon={faXmark}
              className="w-5 h-5 mt-1.5 text-primary cursor-pointer"
            />
          </Link>
        </div>
      </div>
      <div className="">
        <div className="flex space-x-1">
          {/* create drawing on google map  */}

          <LoadScript
            libraries={["drawing"]}
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
          >
            <GoogleMap
              id="marker-example"
              mapContainerStyle={containerStyle}
              // mapContainerStyle={containerStyle}
              center={center}
              zoom={5}

              // onLoad={onLoad}
              // onUnmount={onUnmount}
            >
              {/* Child components, such as markers, info windows, etc. */}
              <DrawingManager
                // onLoad={onLoad}
                onPolygonComplete={(poly) => {
                  poly
                    .getPath()
                    .getArray()
                    .forEach((latLng) => {
                      path.push({
                        geometry: {
                          location: { lat: latLng.lat(), lng: latLng.lng() },
                        },
                      });
                    });

                  setregion({ ...region, locationPoints: path });

                  path.forEach((element) => {
                    var latitude = (element.lat * Math.PI) / 180;
                    var longitude = (element.lng * Math.PI) / 180;

                    x += Math.cos(latitude) * Math.cos(longitude);
                    y += Math.cos(latitude) * Math.sin(longitude);
                    z += Math.sin(latitude);
                  });

                  var total = path.length;

                  x = x / total;
                  y = y / total;
                  z = z / total;

                  var centralLongitude = Math.atan2(y, x);
                  var centralSquareRoot = Math.sqrt(x * x + y * y);
                  var centralLatitude = Math.atan2(z, centralSquareRoot);

                  // center = {
                  //   lat: (centralLatitude * 180) / Math.PI,
                  //   lng: (centralLo ngitude * 180) / Math.PI,
                  // };
                  setcenter({
                    lat: (centralLatitude * 180) / Math.PI,
                    lng: (centralLongitude * 180) / Math.PI,
                  });
                }}
                options={{
                  drawingControl: true,
                  drawingControlOptions: {
                    drawingModes: ["polygon"],
                  },
                  polygonOptions: {
                    strokeColor: "#FF0000",
                    fillOpacity: 0.35,
                    strokeWeight: 5,
                    clickable: false,
                    editable: true,
                    draggable: true,
                    zIndex: 1,
                  },
                }}
              />
              <></>
            </GoogleMap>
          </LoadScript>
          <div className="my-3 shadow-md w-full space-y-5">
            <div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Enter Region Name
                </div>
                <input
                  type="text"
                  placeholder="Enter Region Name"
                  className="focus:outline-none border-b-2 border-gray-300  py-1 w-full textField"
                  onChange={(e) => {
                    setregion({ ...region, name: e.target.value });
                  }}
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Distance Unit
                </div>
                <input
                  type="text"
                  placeholder="Enter Region Name"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  value="km"
                />
              </div>
              <div className="mx-2 my-2">
                <div className="text-sm text-gray-600 font-semibold">
                  Distance per hour
                </div>
                <input
                  type="text"
                  placeholder="Enter distance per hour"
                  className="focus:outline-none border-b-2 border-gray-300 w-full py-1 textField"
                  value={
                    region.distance_per_hour === 0
                      ? 20
                      : region.distance_per_hour
                  }
                  onChange={(e) => {
                    setregion({ ...region, distance_per_hour: e.target.value });
                  }}
                />
              </div>
            </div>
            <div>
              <div className="space-y-5">
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    className="bg-primary text-white "
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{
                      backgroundColor: "#fb4156 ",
                      fontSize: "15px",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    <div>Rates By Milage</div>
                  </AccordionSummary>
                  <AccordionDetails className="flex flex-col">
                    <div className="flex justify-between">
                      <div></div>

                      <div
                        onClick={() => {
                          // setratesOfVehicle({
                          //   ...ratesOfVehicle,
                          //   "": {},
                          // });
                          setratesByMilage([
                            ...ratesByMilage,
                            {
                              v_id: Math.random().toString(36).substr(2, 9),
                            },
                          ]);
                        }}
                        className="flex border-teal-600 border px-2 py-1 rounded-sm text-teal-600 font-semibold hover:shadow-md  items-center w-min  space-x-1 cursor-pointer"
                      >
                        <div className="text-sm">Add</div>
                        <FontAwesomeIcon icon={faAdd} className=" " />
                      </div>
                    </div>
                    {/* {allVehicles.map((vehicle) => ( */}

                    {ratesByMilage?.map((rate, key) => {
                      return (
                        <>
                          <div
                            key={rate?.v_id}
                            className="flex items-center space-x-9 mb-3 border-b  border-gray-500 "
                          >
                            <div>
                              <div className="text-sm text-gray-600">
                                Choose Category
                              </div>
                              {rate?.v_id ? (
                                <Select
                                  className="w-56"
                                  value={{
                                    value: rate?.category,
                                    label: rate?.category?.name,
                                  }}
                                  onChange={(e) => {
                                    setratesByMilage((prev) => {
                                      let newRates = [...prev];
                                      newRates[key].category = e.value;
                                      return newRates;
                                    });
                                  }}
                                  options={categories.map((category) => {
                                    return {
                                      value: category,
                                      label: category?.name,
                                    };
                                  })}
                                />
                              ) : (
                                <div className="w-52">
                                  {rate?.category?.name}
                                </div>
                              )}
                            </div>
                            <div>
                              <div>Choose Vechicle</div>
                              {rate?.v_id ? (
                                <Select
                                  className="w-60"
                                  value={{
                                    value: rate?.vehicleName,
                                    label: rate?.vehicleName,
                                  }}
                                  onChange={(e) => {
                                    setratesByMilage((prev) => {
                                      let newRates = [...prev];
                                      newRates[key].vehicleName =
                                        e?.value?.vehicleName;
                                      return newRates;
                                    });
                                  }}
                                  options={rate?.category?.vehicles.map(
                                    (vehicle) => {
                                      return {
                                        value: vehicle,
                                        label: vehicle?.vehicleName,
                                      };
                                    }
                                  )}
                                />
                              ) : (
                                <div className="w-60">{rate?.vehicleName}</div>
                              )}
                            </div>
                            <div>
                              <div>Start Fee</div>

                              <input
                                type="number"
                                className="textField w-20 mb-1"
                                value={
                                  ratesByMilage[key]?.start_fee
                                    ? ratesByMilage[key]?.start_fee
                                    : rate?.start_fee
                                }
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      start_fee: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>Rate</div>
                              <input
                                value={rate?.rate}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      rate: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>Min Fare</div>
                              <input
                                value={rate?.min_fare}
                                type="number"
                                className="textField w-20 mb-1"
                                onChange={(e) => {
                                  setratesByMilage((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      min_fare: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div className="flex items-center">
                              <FontAwesomeIcon
                                onClick={() => {
                                  setratesByMilage((prev) => {
                                    let tmp = [...prev];

                                    tmp.splice(key, 1);

                                    return tmp;
                                  });
                                }}
                                icon={faTrash}
                                className="text-red-500  cursor-pointer hover:text-red-700"
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    className="bg-primary text-white"
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{
                      backgroundColor: "#fb4156 ",
                      fontSize: "15px",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    <div>Rates By Hour</div>
                  </AccordionSummary>
                  <AccordionDetails className="flex flex-col">
                    <div className="flex justify-between">
                      <div></div>

                      <div
                        onClick={() => {
                          setratesByHour([
                            ...ratesByHour,
                            {
                              v_id: Math.random().toString(36).substr(2, 9),
                            },
                          ]);
                        }}
                        className="flex border-teal-600 border px-2 py-1 rounded-sm text-teal-600 font-semibold hover:shadow-md  items-center w-min  space-x-1 cursor-pointer"
                      >
                        <div className="text-sm">Add</div>
                        <FontAwesomeIcon icon={faAdd} className=" " />
                      </div>
                    </div>
                    {ratesByHour?.map((rate, key) => {
                      return (
                        <>
                          <div className="flex items-center space-x-9 mb-3  border-gray-500 ">
                            <div>
                              <div className="text-sm text-gray-600">
                                Choose Category
                              </div>
                              {rate?.v_id ? (
                                <Select
                                  className="w-56"
                                  value={{
                                    value: rate?.category,
                                    label: rate?.category?.name,
                                  }}
                                  onChange={(e) => {
                                    setratesByHour((prev) => {
                                      let newRates = [...prev];
                                      newRates[key].category = e.value;
                                      return newRates;
                                    });
                                  }}
                                  options={categories.map((category) => {
                                    return {
                                      value: category,
                                      label: category?.name,
                                    };
                                  })}
                                />
                              ) : (
                                <div className="w-52">
                                  {rate?.category?.name}
                                </div>
                              )}
                            </div>
                            <div>
                              <div>Choose Vechicle</div>
                              {rate?.v_id ? (
                                <Select
                                  className="w-60"
                                  value={{
                                    value: rate?.vehicleName,
                                    label: rate?.vehicleName,
                                  }}
                                  onChange={(e) => {
                                    setratesByHour((prev) => {
                                      let newRates = [...prev];
                                      newRates[key].vehicleName =
                                        e.value?.vehicleName;
                                      return newRates;
                                    });
                                  }}
                                  options={rate?.category?.vehicles.map(
                                    (vehicle) => {
                                      return {
                                        value: vehicle,
                                        label: vehicle?.vehicleName,
                                      };
                                    }
                                  )}
                                />
                              ) : (
                                <div className="w-52">{rate?.vehicleName}</div>
                              )}
                            </div>
                            <div>
                              <div>Start Fee</div>
                              <input
                                type="number"
                                value={rate?.start_fee}
                                className="textField w-20"
                                onChange={(e) => {
                                  setratesByHour((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      start_fee: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>Rate</div>
                              <input
                                value={rate?.rate}
                                type="number"
                                className="textField w-20"
                                onChange={(e) => {
                                  setratesByHour((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      rate: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div>
                              <div>Min Fare</div>
                              <input
                                value={rate?.min_fare}
                                type="number"
                                className="textField w-20"
                                onChange={(e) => {
                                  setratesByHour((prev) => {
                                    let newRates = [...prev];
                                    newRates[key] = {
                                      ...newRates[key],
                                      min_fare: parseFloat(e.target.value),
                                    };
                                    return newRates;
                                  });
                                }}
                              />
                            </div>
                            <div className="flex items-center">
                              <FontAwesomeIcon
                                onClick={() => {
                                  // first get the index of the vehicle
                                  // then remove it from the array

                                  setratesByHour((prev) => {
                                    let tmp = [...prev];

                                    tmp.splice(key, 1);

                                    return tmp;
                                  });
                                }}
                                icon={faTrash}
                                className="text-red-500  cursor-pointer hover:text-red-700"
                              />
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CreateRegion);
